import makeStyles from '@mui/styles/makeStyles';
import { appPalette } from 'theme/App.palette';

const { acura_red, black, mid_grey_2, black_o01, light_grey_7 } =
  appPalette.colors;

export const useStyles = makeStyles({
  hidden: {
    display: 'none',
  },
  container: {
    position: 'relative',
    border: `0.0625rem solid ${mid_grey_2}`,
    borderRadius: '0.25rem',
    height: '2.875rem',
  },
  placeholder: {
    width: '100%',
    height: '100%',
    padding: '0 1.25rem',
    color: 'black',
    textTransform: 'none',
    justifyContent: 'flex-start',
    '&:after': {
      top: 'calc(50% - 0.1875rem)',
      right: 0,
      marginRight: '1.25rem',
      width: '0.8125rem',
      height: '0.8125rem',
      content: '""',
      display: 'block',
      zIndex: '2',
      position: 'absolute',
      transform: 'translateY(-50%) rotate(135deg)',
      borderTop: `0.1875rem solid ${acura_red}`,
      borderRight: `0.1875rem solid ${acura_red}`,
      pointerEvents: 'none',
    },
    '&.select-open': {
      '&:after': {
        transform: 'rotate(315deg)',
      },
    },
    '&.Mui-focusVisible': {
      'body:not(.acr-focus-disabled) &': {
        outline: `0.125rem solid`,
        outlineOffset: '0.1875rem',
        outlineColor: black,
      },
    },
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  popper: {
    width: 'calc(100% + 0.125rem)',
    zIndex: 11,
  },
  menu_container: {
    width: '100%',
    padding: 0,
    zIndex: 2,
    border: `0.0625rem solid ${mid_grey_2}`,
    boxShadow: '0 0.125rem 1.875rem 0 rgb(0 0 0 / 10%)',
    borderTop: 0,
    overflowY: 'scroll',
    maxHeight: '20rem',
    '&::-webkit-scrollbar': {
      width: '0.3em',
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 0.375rem transparent',
      webkitBoxShadow: 'inset 0 0 0.375rem transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: black_o01,
      outline: `0.0625rem solid ${light_grey_7}`,
    },
    '&.hide-input': {
      borderTop: `0.0625rem solid ${mid_grey_2}`,
    },
  },
  menu_item: {
    position: 'relative',
    padding: '0.625rem',
    wordWrap: 'break-word',
    whiteSpace: 'normal',
    minHeight: 'unset',
    '&.Mui-focusVisible': {
      'body:not(.acr-focus-disabled) &': {
        outline: `0.125rem solid`,
        outlineOffset: '-0.125rem',
        outlineColor: black,
      },
    },
    '&.Mui-selected, &.Mui-selected:hover': {
      backgroundColor: 'white',
    },
  },
});
